import { Column, ColumnName, Answer,CreateRandomBoardResultProps} from "../types/types";
import InitPerson from "../hooks/InitPerson";

export const createEmptyBoard = (): Column[] => {
  const columns: ColumnName[] = ["a", "b", "c", "d", "e"];

  return columns.map((col) => ({
    name: col,
    rooms: [1, 2, 3, 4].map((num) => ({
      id: num,
      column: col,
      characterId: null,
      lightOn: false,
      isOpen: false,
    })),
  }));
};


export const CreateRandomBoard = (
  CHAR_COUNT: number,
): CreateRandomBoardResultProps => {
  const board = createEmptyBoard();
  const flatRooms = board.flatMap((col) => col.rooms);

  const shuffledRooms = [...flatRooms].sort(() => Math.random() - 0.5);

  const selectedChars = [...InitPerson]
    .sort(() => Math.random() - 0.5)
    .slice(0, CHAR_COUNT);

  const correct: Answer[] = [];

  selectedChars.forEach((char, index) => {
    const room = shuffledRooms[index];

    room.characterId = char.id;
    room.isOpen = false;
    room.lightOn = false;

    const visualRow = 5 - room.id;

    correct.push({
      idCharecter: char.id,
      input: "",
      position: {
        column: room.column,
        roomId: visualRow,
      },
    });
  });

  return { board, correct, selectedIds: selectedChars.map((c) => c.id) };
};
